var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgWarehouse = function SvgWarehouse(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 3.292 3.4 8.667V19.6h17.2V8.667zM15.95 18.4h-7.9v-3.351h7.9zm3.45 0h-2.35v-4.45H6.95v4.45H4.6V9.333L12 4.708l7.4 4.625z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.3 9.9H7v2.3h2.3zm3.867 0h-2.3v2.3h2.3zM17 9.9h-2.3v2.3H17z"
  })));
};
export { SvgWarehouse as ReactComponent };
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'%3e%3cpath fill='currentColor' fill-rule='evenodd' d='M12 3.292 3.4 8.667V19.6h17.2V8.667zM15.95 18.4h-7.9v-3.351h7.9zm3.45 0h-2.35v-4.45H6.95v4.45H4.6V9.333L12 4.708l7.4 4.625z' clip-rule='evenodd'/%3e%3cpath fill='currentColor' d='M9.3 9.9H7v2.3h2.3zm3.867 0h-2.3v2.3h2.3zM17 9.9h-2.3v2.3H17z'/%3e%3c/svg%3e";